define('taoQtiItem/qtiXmlRenderer/renderers/interactions/MatchInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/matchInteraction'], function(tpl){
    return {
        qtiClass : 'matchInteraction',
        template : tpl
    };
});
